import { render } from "./TicketsSummary.vue?vue&type=template&id=87429868&scoped=true"
import script from "./TicketsSummary.vue?vue&type=script&lang=js"
export * from "./TicketsSummary.vue?vue&type=script&lang=js"

import "./TicketsSummary.vue?vue&type=style&index=0&id=87429868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87429868"]])

export default __exports__